export default function getBallotsReducer(state=[], action) {
    switch(action.type){
        case "get_ballots_suc": {
            return action.payload
        }
        default: {
            return state
        }
    }
}